var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"fixed -top-12 opacity-0 pointer-events-none",attrs:{"tabindex":"-1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }